import { App } from 'vue';

import SvgIcon from '@/components/SvgIcon.vue';
import HeadTitle from '@/components/HeadTitle.vue';
import ToolTipSelect from '@/components/ToolTipSelect/index.vue';
import { SaveBtn } from '@/components/button/index';

// 全局Compontents
export function customComponents(app: App) {
  app.component('SvgIcon', SvgIcon);
  app.component('HeadTitle', HeadTitle);
  app.component('ToolTipSelect', ToolTipSelect);
  app.component('SaveBtn', SaveBtn);
}
